import React from "react";
import { useTranslation } from "react-i18next";
import InputAutoresize from "../../../../common/components/form/InputAutoresize.jsx";

const VK = "ProductDescription"; // VariablesKey
export default function ProductDescription(props) {
    const { t } = useTranslation();

    const { set, variables } = props;

    function onChange(event) {
        set({ ...variables, [VK]: event.target.value });
    }

    function onBlur(event) {
        set({ ...variables, [VK]: event.target.value.trim() });
    }

    return (
        <>
            <h3 className="text-left">{t("Product Description")}:</h3>

            <p className="text-left">
                {t(
                    "Describe us what you want to sell or promote and why your customers should apply to your offer. We will  help you with professional sales oriented and SEO optimised text to boost your sales."
                )}
            </p>

            <InputAutoresize
                onChange={onChange}
                onBlur={onBlur}
                value={variables[VK]}
                placeholder={t("Start typing")}
                fullWidth
                multirow
                rows={6}
            />
        </>
    );
}
